import React from 'react';

const TermsOfService = () => {
    return (
        <div className='w-full text-gray-800 dark:text-gray-300 py-24 px-4 bg-white dark:bg-[#0a1220] transition-colors duration-300'>
            <div className='max-w-[1000px] mx-auto'>
                <h1 className='text-4xl font-bold mb-8 text-secondary'>Terms of Service</h1>

                <p className='mb-4 text-sm text-gray-500'>Last updated: {new Date().toLocaleDateString()}</p>

                <section className='mb-8'>
                    <h2 className='text-2xl font-semibold mb-4 text-gray-900 dark:text-white'>1. Acceptance of Terms</h2>
                    <p className='mb-4'>
                        By accessing and using DataHelix ("the Service"), you agree to comply with and be bound by these Terms of Service.
                        If you do not agree to these terms, please do not use the Service.
                    </p>
                </section>

                <section className='mb-8'>
                    <h2 className='text-2xl font-semibold mb-4 text-gray-900 dark:text-white'>2. Educational Content</h2>
                    <p className='mb-4'>
                        The content provided on DataHelix, including but not limited to SQL exercises, case studies, and tutorials, is for educational purposes only.
                        While we strive for accuracy, we make no guarantees regarding the completeness or reliability of any information.
                    </p>
                </section>

                <section className='mb-8'>
                    <h2 className='text-2xl font-semibold mb-4 text-gray-900 dark:text-white'>3. User Accounts</h2>
                    <p className='mb-4'>
                        To access certain features, you may be required to create an account. You are responsible for maintaining the confidentiality of your account
                        credentials and for all activities that occur under your account.
                    </p>
                </section>

                <section className='mb-8'>
                    <h2 className='text-2xl font-semibold mb-4 text-gray-900 dark:text-white'>4. Intellectual Property</h2>
                    <p className='mb-4'>
                        The Service and its original content, features, and functionality are and will remain the exclusive property of DataHelix and its licensors.
                        The Service is protected by copyright, trademark, and other laws.
                    </p>
                </section>

                <section className='mb-8'>
                    <h2 className='text-2xl font-semibold mb-4 text-gray-900 dark:text-white'>5. Termination</h2>
                    <p className='mb-4'>
                        We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation
                        if you breach the Terms.
                    </p>
                </section>

                <section className='mb-8'>
                    <h2 className='text-2xl font-semibold mb-4 text-gray-900 dark:text-white'>6. Changes to Terms</h2>
                    <p className='mb-4'>
                        We reserve the right, at our sole discretion, to modify or replace these Terms at any time. By continuing to access or use our Service after
                        those revisions become effective, you agree to be bound by the revised terms.
                    </p>
                </section>

            </div>
        </div>
    );
};

export default TermsOfService;
